// extracted by mini-css-extract-plugin
export default {"sidebar":"ChatSidebar_sidebar__pfiYm","hovered":"ChatSidebar_hovered__RFoqj","show-sidebar-btn":"ChatSidebar_show-sidebar-btn__3dTKF","show-chat":"ChatSidebar_show-chat__RjN6p"};